import Dialog from '@mui/material/Dialog'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { cn } from 'src/lib/utils'

const getSubOptions = (esgType) => {
    switch(esgType) {
        case 'Environment':
            return [
                { value: 'E1', label: 'หมวดการจัดการสิ่งแวดล้อม' },
                { value: 'E2', label: 'หมวดการใช้ทรัพยากรอย่างมีประสิทธิภาพ' },
                { value: 'E3', label: 'หมวดการจัดการด้านสภาพภูมิอากาศ' }
            ];
        case 'Social':
            return [
                { value: 'S1', label: 'หมวดการเคารพสิทธิมนุษยชนและการปฎิบัติต่อแรงงานอย่างเป็นธรรม' },
                { value: 'S2', label: 'หมวดการพัฒนาศักยภาพแก่พนักงาน' },
                { value: 'S3', label: 'หมวดการจูงใจและรักษาพนักงาน' },
                { value: 'S4', label: 'หมวดสุขภาวะและความปลอดภัยในสภาพแวดล้อมการทำงาน' },
                { value: 'S5', label: 'หมวดการมีส่วนร่วมกับชุมชนและสังคม' },
                { value: 'S6', label: 'หมวดการมีส่วนร่วมของผู้มีส่วนได้เสีย' }
            ];
        case 'Governance & Economic':
            return [
                { value: 'G1', label: 'หมวดบรรษัทภิบาล' },
                { value: 'G2', label: 'หมวดจรรยาบรรณธุรกิจ ( Code of Conduct ) และการต่อต้านการทุจริต' },
                { value: 'G3', label: 'หมวดการระบุประเด็นที่เป็นสาระสำคัญของธุรกิจ ( Materiality )' },
                { value: 'G4', label: 'หมวดการบริหารความเสี่ยงและภาวะวิกฤต' },
                { value: 'G5', label: 'หมวดการบริหารจัดการความสัมพันธ์กับลูกค้า' },
                { value: 'G6', label: 'หมวดการบริหารจัดการห่วงโซ่อุปทาน' },
                { value: 'G7', label: 'หมวดการดำเนินการด้านภาษี' },
                { value: 'G8', label: 'หมวดนวัตกรรมทางธุรกิจเพื่อสังคมและ/หรือสิ่งแวดล้อม' },
                { value: 'G9', label: 'หมวดความปลอดภัยของข้อมูลและระบบสนเทศ' },
                { value: 'G10', label: 'หมวดการบริหารคุณภาพการให้บริการ' }
            ];
        default:
            return [];
    }
};


function Widget({data, year, compareData, compareYear, dragAble}) {
    const [open, setOpen] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);

    let latestYear;
    if (typeof year === 'string') {
    latestYear = Math.max(...year.split(',').map(Number));
    } else if (Array.isArray(year)) {
    latestYear = Math.max(...year.map(Number));
    } else if (typeof year === 'number') {
    latestYear = year;
    } else {
    latestYear = undefined;
    }

    const handleOpen = () => {
        if(!dragAble){
            setOpen(true);
        }
    }
    const handleClose = () => setOpen(false);

    const logoMapping = [
        { id: "1", type: "sdg" },
        { id: "2", type: "sdg" },
        { id: "3", type: "sdg" },
        { id: "4", type: "sdg" },
        { id: "5", type: "sdg" },
        { id: "6", type: "sdg" },
        { id: "7", type: "sdg" },
        { id: "8", type: "sdg" },
        { id: "9", type: "sdg" },
        { id: "10", type: "sdg" },
        { id: "11", type: "sdg" },
        { id: "12", type: "sdg" },
        { id: "13", type: "sdg" },
        { id: "14", type: "sdg" },
        { id: "15", type: "sdg" },
        { id: "16", type: "sdg" },
        { id: "17", type: "sdg" }
    ];


    const normalizeGRI = (value) => {
        return value
            .toUpperCase()
            .replace(/GIR/g, 'GRI')                  
            .replace(/[^A-Z0-9]+/g, ' ')              
            .replace(/([A-Z]+)(\d+)/g, '$1 $2')    
            .replace(/\s+/g, ' ')                  
            .trim();
    };
    

    const isMismatchBetweenYears = () => {
        const mainSDG = data?.rawData?.sdGoal || [];
        const compareSDG = compareData?.rawData?.sdGoal || [];

        const normalizeArray = (arr) =>
            [...new Set(arr.map(val => parseInt(val)).filter(Boolean))];

        const sdgMain = normalizeArray(mainSDG);
        const sdgCompare = normalizeArray(compareSDG);
        const sdgMismatch =
            sdgMain.length !== sdgCompare.length ||
            sdgMain.some(val => !sdgCompare.includes(val));

        const mainGRI = Array.isArray(data?.rawData?.griStandard)
            ? data.rawData.griStandard
            : String(data?.rawData?.griStandard || '')
                .split(',')
                .map(s => s.trim())
                .filter(Boolean);

        const compareGRI = Array.isArray(compareData?.rawData?.griStandard)
            ? compareData.rawData.griStandard
            : String(compareData?.rawData?.griStandard || '')
                .split(',')
                .map(s => s.trim())
                .filter(Boolean);

        const isValidGRI = (s) => s.toUpperCase().startsWith('GRI ');
        const invalidGRI = [...mainGRI, ...compareGRI].some(s => !isValidGRI(s));

        const griMismatch = (mainGRI.length || compareGRI.length) > 0 && invalidGRI;

        return sdgMismatch || griMismatch;
    };


    useEffect(() => {
        if (compareYear && isMismatchBetweenYears()) {
            setShowWarningModal(true);
        } else {
            setShowWarningModal(false);
        }
    }, [compareYear, data, compareData]);

    const thaiName = data?.rawData?.esgType && data?.rawData?.subType && (() => {
        const options = getSubOptions(data.rawData.esgType);
        const selectedOption = options.find(opt => opt.value === data.rawData.subType);
        return selectedOption ? `${selectedOption.label}` : '';
    })();


    return (
        <div className="">
            <div
                className={cn('h-auto min-h-[17.1rem] w-full bg-white text-black border-[3px] p-3 sm:p-4 rounded-xl shadow-sm cursor-pointer hover:shadow-md transition-shadow', {
                    // "border-[#0085FF]": data?.id >= 1 && data?.id <= 3, 
                    // "border-[#FFA800]": data?.id >= 4 && data?.id <= 7,
                    // "border-[#1FA37C]": data?.id >= 8 && data?.id <= 10

                    "border-[#1FA37C]": data?.rawData?.esgType?.includes('E'),
                    "border-[#FFA800]": data?.rawData?.esgType?.includes('S'),
                    "border-[#0085FF]": data?.rawData?.esgType?.includes('G')
                })}
                onClick={handleOpen}
            >
                <div className='flex flex-col h-full justify-between'>
                    <div className='flex items-center justify-between'>
                        <h2 className='text-base sm:text-lg font-semibold line-clamp-2'>
                            {thaiName}
                        </h2>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                        </svg>
                    </div>

                    <div className='flex-grow mt-4 sm:mt-8'>
                        <div className='gap-1 sm:gap-2 inline-flex text-xs font-medium flex-wrap'>

                            {Array.isArray(data?.rawData?.griStandard)
                                ? [...new Set(data?.rawData?.griStandard.map(normalizeGRI))].map((standard, idx) => (
                                    <span className="text-[#528ACC] bg-[#EFF4FA] px-2 py-1 rounded-full text-xs font-medium" key={idx}>{standard}</span>
                                ))
                                : [...new Set(String(data?.rawData?.griStandard).split(',').map(normalizeGRI))].map((standard, idx) => (
                                    <span className="text-[#528ACC] bg-[#EFF4FA] px-2 py-1 rounded-full text-xs font-medium" key={idx}>{standard}</span>
                                ))
                            }
                        </div>
                    </div>

                    <div className='inline-flex items-center gap-1 sm:gap-2 mt-4 sm:mt-0 flex-wrap'>
                     
                        {logoMapping?.map((item) => {
                            const isIncluded = Array.isArray(data?.rawData?.sdGoal) 
                                ? data?.rawData?.sdGoal?.includes(parseInt(item?.id))
                                : data?.rawData?.sdGoal === parseInt(item?.id);
                            
                            return isIncluded && (
                                <img 
                                    key={item?.id}
                                    src={`https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-${String(item.id).padStart(2, '0')}.jpg`}
                                    alt={`SDG Goal ${item.id}`} 
                                    className='w-6 h-6 sm:w-8 sm:h-8 object-contain' 
                                />
                            );
                        })}
                    </div>
                </div>
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="xl"
                fullWidth
                PaperProps={{
                    style: { borderRadius: 12 }
                }}
            >
                <div className={`p-6 border-4 border-[${data?.color}] rounded-lg`}>
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-2xl font-semibold">
                            {thaiName}
                        </h2>
                        <button onClick={handleClose} className="text-gray-500 hover:text-gray-700">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {compareYear && showWarningModal && (
                    <Dialog open={showWarningModal} onClose={() => setShowWarningModal(false)} maxWidth="sm" fullWidth>
                        <div className="p-4 md:p-6">
                            <p>มีข้อความที่กรอกเข้ามาบางส่วนของ SD Goal หรือ GRI ของ <span className='font-semibold'>{thaiName}</span> ของปี {compareYear} ไม่ตรงกับปี {latestYear} คุณต้องแก้ไขข้อความให้ตรงกันหรือไม่ ?</p>
                            <div className="flex justify-center gap-2 py-6">
                                <button onClick={() => setShowWarningModal(false)} className="px-6 py-2 text-white bg-red-600 rounded-lg hover:bg-red-600/80">
                                    ไม่ต้องการ
                                </button>
                                <Link to={'/data-source-mng'} className='bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] rounded-lg text-white px-4 py-2'>ต้องการแก้ไข</Link>
                            </div>
                        </div>
                    </Dialog>
                    )}


                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50 divide-y divide-gray-200">
                            <tr>
                                <th className="text-left font-semibold text-gray-600 uppercase tracking-wider">ประเด็น</th>
                                <th className="text-left font-semibold text-gray-600 tracking-wider">SD Goals</th>
                                <th className="text-left font-semibold text-gray-600 uppercase tracking-wider">GRI</th>
                                <th className="text-left font-semibold text-gray-600 uppercase tracking-wider">ตัวชี้วัด</th>
                                <th className="text-left font-semibold text-gray-600 uppercase tracking-wider">เป้าหมาย</th>
                                <th className="text-left font-semibold text-gray-600 uppercase tracking-wider">
                                {compareYear ? `ผลงาน ${compareYear}` : `ผลงาน ${year}`}
                                </th>
                                {compareYear && (
                                <th className="text-left font-semibold text-white bg-orange tracking-wider border border-orange">
                                    ผลงาน {latestYear}
                                </th>
                                )}
                                <th className="text-left font-semibold text-gray-600 uppercase tracking-wider">หน่วยงานหลัก</th>
                            </tr>
                            </thead>
                            <tbody className="bg-white ">
                            {(() => {
                                const dataMain = data?.rawData || {};
                                const compareMain = compareData?.rawData || {};
                                

                                const grouped = {
                                topic: getSubOptions(dataMain?.esgType || '')?.find(opt => opt.value === dataMain?.subType)?.label || '',
                                sdGoal: dataMain?.sdGoal,
                                griStandard: dataMain?.griStandard,
                                topic_list: dataMain?.topic_list || []
                                };


                                return grouped.topic_list.map((item, i) => (
                                <tr key={i} className={`hover:bg-gray-50 align-top ${i === 0 ? '' : 'border-t border-gray-200'}`}>
                                    {i === 0 ? (
                                        <>
                                            <td className={`min-w-[12rem] whitespace-normal break-all text-left`}>
                                                {grouped.topic}
                                            </td>

                                            <td className={`w-[150px]`}>
                                                <div className="grid grid-cols-2 gap-1">
                                                    {logoMapping?.map((logoItem) => {
                                                        const isIncluded = Array.isArray(grouped.sdGoal)
                                                            ? grouped.sdGoal.includes(parseInt(logoItem.id))
                                                            : grouped.sdGoal === parseInt(logoItem.id);
                                                        return isIncluded && (
                                                            <img
                                                                key={logoItem.id}
                                                                src={`https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-${String(logoItem.id).padStart(2, '0')}.jpg`}
                                                                alt={`SDG Goal ${logoItem.id}`}
                                                                className="object-full"
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            </td>

                                            <td className={`flex flex-col gap-2`}>
                                                {Array.isArray(grouped.griStandard)
                                                    ? [...new Set(grouped.griStandard.map(normalizeGRI))].map((standard, idx) => (
                                                        <span key={idx}>{standard}</span>
                                                    ))
                                                    : [...new Set(String(grouped.griStandard).split(',').map(normalizeGRI))].map((standard, idx) => (
                                                        <span key={idx}>{standard}</span>
                                                    ))
                                                }
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </>
                                    )}

                                    <td className="text-sm min-w-[12rem] h-[8rem] align-top whitespace-pre-wrap break-all text-left">
                                        {compareYear ? compareMain?.topic_list?.[i]?.measurement || '' : item.measurement}
                                    </td>
                                    <td className="text-sm min-w-[12rem] align-top whitespace-pre-wrap break-all">
                                        {compareYear ? compareMain?.topic_list?.[i]?.target || '' : item.target}
                                    </td>
                                    <td className="text-sm min-w-[12rem] align-top whitespace-pre-wrap break-all">
                                        {compareYear ? compareMain?.topic_list?.[i]?.target_and_achieved || '' : item.target_and_achieved}
                                    </td>
                                    {compareYear && (
                                        <td className="text-sm border border-orange bg-orange text-white min-w-[12rem] align-top whitespace-pre-wrap break-all">
                                            {dataMain?.topic_list?.[i]?.target_and_achieved || ''}
                                        </td>
                                    )}
                                    <td className="text-sm min-w-[12rem] align-top whitespace-pre-wrap break-all">
                                        {compareYear ? compareMain?.topic_list?.[i]?.operation_team || '' : item.operation_team}
                                    </td>
                                </tr>

                                ));
                            })()}
                            </tbody>
                        </table>
                    </div>

                </div>
            </Dialog>
        </div>
    )
}

export default Widget
